module.exports = __webpack_public_path__ + "img/Biosanitarios.a46ecb13.png";